import React, { Component } from "react";

import {
  CButton,
  CCol,
  CModalBody,
  CModalFooter,
  CModalHeader,
  CModalTitle,
  CPagination,
  CRow,
  CModal,
  CInput
} from "@coreui/react";
import { connect } from "react-redux";
import { toastr } from "react-redux-toastr";
import { bindActionCreators } from "redux";

import { logout } from "../../actions/baseActions";
import { setObj } from "../../actions/noteActions";
import URL from "../../config/api";
import axios from "../../config/axios";
import Loading from "../Loading";

import "./styles.css";

class QuestionListImportModal extends Component {
  constructor() {
    super();
    this.state = {
      selectedList: undefined,
      importedLists: [],
      loading: true,
      // maxItems: 12,
      currentPage: 1,
      lastPage: 1,
      modalDelete: false,
      idDelete: null,
      search: ""
    };
  }

  componentDidMount() {
    this.handleLists();
  }

  async handleLists() {
    const userId = this.props.user.user.id;
    this.setState({ loading: true });
    const listsResponse = await axios.post(
      `${URL.api}evaluation/question/lists/list?page=${this.state.currentPage}&page_size=12`,
      { user_id: userId },
      { headers: { authorization: `Bearer ${this.props.user.token}` } }
    );

    if (listsResponse.data.success) {
      const importedListsArray = listsResponse.data.data.slice().map(list => {
        list.selected = false;
        return list;
      });

      importedListsArray.sort((a, b) => {
        if (a.created_at > b.created_at) return -1;
        if (a.created_at < b.created_at) return 1;
        return 0;
      });
      this.setState({
        importedLists: importedListsArray,
        loading: false,
        currentPage: listsResponse.data.meta.current_page,
        lastPage: listsResponse.data.meta.last_page
      });
    }
  }

  selectList(id, name, index) {
    // eslint-disable-next-line react/no-access-state-in-setstate
    const newListsArray = this.state.importedLists.slice().map(list => {
      list.selected = false;
      return list;
    });
    newListsArray.find(list => list.id === id).selected = true;

    this.setState({
      selectedList: { id, name },
      importedLists: newListsArray
    });
  }

  deleteList(list) {
    if (list.used > 0) {
      toastr.warning(
        "Falha ao excluir",
        "A lista já foi aplicada em uma atividade"
      );
      return;
    }

    this.setState({ modalDelete: true, idDelete: list.id });
  }

  deleteListById() {
    axios
      .post(
        `${URL.api}evaluation/question/lists/delete`,
        { id: this.state.idDelete },
        { headers: { Authorization: `Bearer ${this.props.user.token}` } }
      )
      .then(
        res => {
          if (res.data.success) {
            this.handleLists();
          } else {
            toastr.error("Erro", "Não foi possível excluir a lista");
          }
        },
        err => {
          toastr.error("Erro", "Não foi possível excluir a lista");
        }
      );

    this.setState({ modalDelete: false });
  }

  render() {
    const lists =
      this.state.importedLists?.filter(item =>
        item.name.toLowerCase().includes(this.state.search.toLowerCase())
      ) || [];

    return (
      <>
        <div className="question-list-import-modal-container">
          <section className="question-list-import-modal-header">
            <h3>Listas de Questões</h3>
            <div className="d-flex align-items-center">
              <CInput
                className="mr-2"
                placeholder="Pesquisar"
                value={this.state.search}
                onChange={e =>
                  this.setState({ search: e.target.value, currentPage: 1 })
                }
              />
              <button
                className="btn btn-primary"
                style={{ whiteSpace: "nowrap" }}
                onClick={() => this.props.newList()}
              >
                Nova Lista
              </button>
            </div>
          </section>
          {this.state.loading ? (
            <section className="question-list-import-modal-list">
              <Loading top="45" left="50" />
            </section>
          ) : (
            <section className="question-list-import-modal-list pb-0">
              <CRow>
                {lists.map((list, index) => (
                  <CCol
                    xl="3"
                    lg="4"
                    md="6"
                    sm="12"
                    key={list.id}
                    className="mb-3"
                  >
                    <div
                      className={
                        list.selected
                          ? "question-list-import-modal-item-selected selectable"
                          : "selectable"
                      }
                      onClick={() => this.selectList(list.id, list.name, index)}
                    >
                      <div className="question-list-import-modal-item">
                        <div className="question-list-import-modal-item-name w-100 text-ellipsis">
                          <div className="text-ellipsis">
                            <h4 id="breakName" className="text-ellipsis">
                              {list.name}
                            </h4>
                            <span className="text-ellipsis">
                              {list.user_name}
                            </span>
                          </div>
                        </div>
                        <div className="question-list-import-modal-item-time-questions-executions">
                          <span>{list.questions}</span>
                          <p>questões</p>
                        </div>
                        <div className="question-list-import-modal-item-time-questions-executions">
                          <span>{list.time}</span>
                          <p>minutos de duração</p>
                        </div>
                        <div className="question-list-import-modal-item-time-questions-executions">
                          {list.execution_quantity > 0 ? (
                            <>
                              <span>{list.execution_quantity}</span>
                              <p>
                                {list.execution_quantity === 1
                                  ? "execução por usuário"
                                  : "execuções por usuário"}
                              </p>
                            </>
                          ) : (
                            <p>Sem limites de execuções</p>
                          )}
                        </div>
                        {/* <div
                            className="d-flex flex-row question-list-import-modal-item-name mb-0 mt-2 justify-content-start"
                            onClick={e => e.stopPropagation()}
                          >
                            {list.execution_quantity < 1 && (
                              <button
                                onClick={() => this.props.editList(list.id)}
                              >
                                <i className="fa fa-pencil mr-2"></i>
                              </button>
                            )}
                            <button
                              onClick={() =>
                                window.open(
                                  `/question/list/prototype/${list.id}`,
                                  "_blank"
                                )
                              }
                            >
                              <i className="fa fa-eye mr-2"></i>
                            </button>
                            <button
                              onClick={() => this.props.cloneList(list.id)}
                            >
                              <i className="fa fa-clone mr-2"></i>
                            </button>
                            <button onClick={() => this.deleteList(list)}>
                              <i className="fa fa-trash"></i>
                            </button>
                          </div> */}
                      </div>
                    </div>
                  </CCol>
                ))}
              </CRow>
            </section>
          )}

          <section className="question-list-import-modal-footer">
            <div className="w-100">
              <CPagination
                className="m-0"
                addListClass="m-0"
                activePage={this.state.currentPage}
                pages={this.state.lastPage}
                onActivePageChange={page =>
                  this.setState({ currentPage: page }, () => this.handleLists())
                }
              />
            </div>
            <button
              className="btn btn-primary"
              // onClick={() =>
              //   this.props.selectedListChanger(this.state.selectedList)
              // }
              onClick={() => this.props.cloneList(this.state.selectedList?.id)}
              disabled={this.state.selectedList?.id === undefined}
            >
              Continuar
            </button>
          </section>
        </div>
        <CModal
          show={this.state.modalDelete}
          onClose={() => this.setState({ modalDelete: false })}
          closeOnBackdrop={false}
        >
          <CModalHeader closeButton className="bg-danger">
            <CModalTitle>Apagar lista de questões</CModalTitle>
          </CModalHeader>
          <CModalBody>Deseja apagar a lista selecionada?</CModalBody>
          <CModalFooter>
            <CButton color="danger" onClick={() => this.deleteListById()}>
              Apagar
            </CButton>{" "}
            <CButton
              color="secondary"
              onClick={() => this.setState({ modalDelete: false })}
            >
              Cancelar
            </CButton>
          </CModalFooter>
        </CModal>
      </>
    );
  }
}

const mapStateToProps = state => ({
  user: state.user,
  general: state.general,
  profile: state.profile
});

function mapDispatchToProps(dispatch) {
  return bindActionCreators(
    {
      logout,
      setObj
    },
    dispatch
  );
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(QuestionListImportModal);
